<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<amountStatistic v-if="activeTab === '1'"></amountStatistic>
			<yearStatistic v-else-if="activeTab === '2'"></yearStatistic>
		</topTab>
	</div>
</template>

<script>
import amountStatistic from "./amountStatistic.vue";
import yearStatistic from "./yearStatistic.vue";
export default {
	components: {
		amountStatistic,
		yearStatistic
	},
	data() {
		return {
			activeTab: "1",
			tabData: [
				{ key: "1", value: "门店收款统计" },
				{ key: "2", value: "年度收款统计" }
			]
		};
	},
	methods: {
		changePages(tab) {
			this.activeTab = tab;
		}
	}
};
</script>

<style scoped></style>
